import { render } from "./SliceSelector.vue?vue&type=template&id=fdb0a66a&scoped=true&ts=true"
import script from "./SliceSelector.vue?vue&type=script&lang=ts"
export * from "./SliceSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb0a66a"]])

export default __exports__